let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aez9w")).then(() => parcelRequire('cjovp'));